/**
 * CSS Loading Fix - Ensures CSS files load properly
 */

(function() {
  'use strict';

  // Check if CSS files are loading properly
  function checkCSSLoading() {
    const stylesheets = document.querySelectorAll('link[rel="stylesheet"]');
    
    stylesheets.forEach(link => {
      // Skip external stylesheets
      if (link.href.includes('googleapis.com') || link.href.includes('shopify.com')) {
        return;
      }
      
      // Check if stylesheet loaded properly
      if (link.sheet === null) {
        console.warn('CSS file failed to load:', link.href);
        
        // Try to reload the stylesheet
        const newLink = document.createElement('link');
        newLink.rel = 'stylesheet';
        newLink.type = 'text/css';
        newLink.href = link.href + (link.href.includes('?') ? '&' : '?') + 'v=' + Date.now();
        
        // Replace the old link
        link.parentNode.insertBefore(newLink, link.nextSibling);
        link.remove();
      }
    });
  }

  // Run check after page load
  window.addEventListener('load', function() {
    setTimeout(checkCSSLoading, 1000);
  });

})();